export default function getDuplicateProductOrderProps(productOrder, props) {
  return {
    ..._.pick(productOrder, [
      'orgId', 'type', 'phone', 'email', 'deliveryAddress', 'billingAddress', 'taxPercentage', 'contactName', 'projectName', 'firmName'
    ]),
    ...props
  };
}
